import styled from "styled-components";
import { Flex, transition } from "@evergis/ui";

export const InputPostfix = styled.div`
  color: ${({ theme: { palette } }) => palette.textSecondary};
`;

export const ParametersRow = styled(Flex)`
  width: 100%;
  justify-content: space-between;
`;

export const DialogForm = styled(Flex)`
  flex-direction: column;
  padding-top: 2.5rem;
`;

export const DialogRow = styled(Flex)`
  flex-direction: row;
  align-items: flex-end;
  margin-bottom: 1rem;
`;

export const AdditionalBlock = styled.div`
  padding-bottom: 1rem;
`;

export const AdditionalBlockButton = styled(Flex)<{ expanded?: boolean }>`
  cursor: pointer;
  align-items: center;
  margin-top: 0.5rem;
  font-size: 0.625rem;
  color: ${({ theme: { palette } }) => palette.primary};

  span[kind] {
    margin-left: 0.5rem;
    transform: rotate(${({ expanded }) => (expanded ? 180 : 0)}deg);
    transition: transform ${transition.release};
    color: ${({ theme: { palette } }) => palette.primary};
  }
`;

export const AdditionalBlockContent = styled.div<{ visible?: boolean }>`
  display: ${({ visible }) => (visible ? "block" : "none")};
`;

export const AdditionalTitle = styled.div`
  margin-top: 1rem;
  color: ${({ theme: { palette } }) => palette.textPrimary};

  button {
    margin-left: 0.5rem;
    display: inline-block;
  }
`;
